module.exports = __webpack_public_path__ + "static/img/w.22015de9.png";